import BaseService from "../BaseService";
import _ from "lodash";

class OrderService extends BaseService {
    list = async (filter) => {
        var data = await this._api.post("/order/list", filter);
        return data;
    };

    get = async ({ id } = {}) => {
        var data = await this._api.post("/order/get", { id });
        return data;
    };

    create = async (order) => {
        var data = await this._api.post("/order/create", order);
        return data;
    };


    update = async (order) => {
        var data = await this._api.post("/order/update", order);
        return data;
    };

    mapProductsFromText = async ({ message_text } = {}) => {
        var data = await this._api.post("/order/map_products_from_text", { message_text });
        return data;
    };

    bulkUpdateShippingStatus = async ({ ids = [], shipping_status_id } = {}) => {
        var data = await this._api.post("/order/bulk_update_shipping_status", { ids, shipping_status_id });
        return data;
    };

    bulkUpdateInternalStatus = async ({ ids = [], internal_status_id } = {}) => {
        var data = await this._api.post("/order/bulk_update_internal_status", { ids, internal_status_id });
        return data;
    };



    createInvoiceFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_invoice", { id });
        return data;
    };

    createPackingListFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_packinglist", { id });
        return data;
    };

    bulkCreatePackingListFile = async ({ ids = [] } = {}) => {
        var data = await this._api.post("/order/bulk_create_packinglist", { ids });
        return data;
    };


    createShippingLabelFile = async ({ id } = {}) => {
        var data = await this._api.post("/order/create_shippinglabel", { id });
        return data;
    };

    bulkCreateShippingLabelFile = async ({ ids = [] } = {}) => {
        var data = await this._api.post("/order/bulk_create_shippinglabel", { ids });
        return data;
    };



    cancel = async ({ id, reason } = {}) => {
        var data = await this._api.post("/order/cancel", { id, reason });
        return data;
    };

    finish = async ({ id, note } = {}) => {
        var data = await this._api.post("/order/finish", { id, note });
        return data;
    };

    createPayment = async ({ id, description, amount, images, date } = {}) => {
        var data = await this._api.post("/order/create_payment", { id, description, amount, images, date });
        return data;
    };



    getPaymentHistory = async (id) => {
        var data = await this._api.post("/order/get_payment_history", { id });
        return data;
    };

    getNotes = async ({ id } = {}) => {
        var data = await this._api.post("/order/get_notes", { id });
        return data;
    };

    getEditHistory = async ({ id } = {}) => {
        var data = await this._api.post("/order/get_edit_history", { id });
        return data;
    };

    addNote = async ({ id, content, images = [], show_to_customer = false } = {}) => {
        var data = await this._api.post("/order/add_note", { id, content, images, show_to_customer });
        return data;
    };

    updateNote = async ({ id, note_id, content, images = [], show_to_customer = false } = {}) => {
        var data = await this._api.post("/order/update_note", { id, note_id, content, images, show_to_customer });
        return data;
    };

    deleteNote = async ({ id, note_id } = {}) => {
        var data = await this._api.post("/order/delete_note", { id, note_id });
        return data;
    };















}
export default OrderService;
